class CustomerFormAPP {
    constructor(container) {
        this.container = document.querySelector(container);
        if (!this.container) {
            throw new Error('Container element not found, skipping app bootstrap');
        }

        this.translations = {
            attachmentEmpty: 'You must attach a file.',
            socialNameEmpty: 'You must enter a social name.',
            cifnifEmpty: 'You must enter a cif/nif.',
            invalidEmail: 'You must enter a valid email.',
            businessTypeRequired: 'Business type is required.'
        };

        this.domElements = {
            email: this.container.querySelector('#email'),
            socialName: this.container.querySelector('#commercial_name'),
            cifnif: this.container.querySelector('#id_number'),
            businesstype: this.container.querySelector('#business_type'),
            submitButton: this.container.querySelector('button[type="submit"]'),
            cancelButton: this.container.querySelector('#cancelButton'),
            files: [
                this.container.querySelector('#file1'),
                this.container.querySelector('#file2'),
                this.container.querySelector('#file3')
            ]
        };

        this.files = {
            file1: {name: null, contents: null},
            file2: {name: null, contents: null},
            file3: {name: null, contents: null}
        };

        this.addModalToDOM();
        this.initEventListeners();
        this.addModalStyles(); // Añadimos estilos directamente

    }

    addModalToDOM() {
        const modalHTML = `
            <div id="formResponseModal" class="modal">
                <div class="modal__container">
                    <button id="ModalClose-formResponse" class="modal__close-button" aria-label="Close">×</button>
                    <div class="modal__content" id="modalContent"></div>
                </div>
            </div>
        `;
        document.body.insertAdjacentHTML('beforeend', modalHTML);
        this.modal = document.getElementById('formResponseModal');

        // Agregar evento para cerrar el modal
        const closeButton = this.modal.querySelector('#ModalClose-formResponse');
        closeButton.addEventListener('click', () => this.hideModal());
    }
    addModalStyles() {
        const styleElement = document.createElement('style');
        styleElement.textContent = `
            .modal {
                display: none;
                position: fixed;
                z-index: 1000;
                left: 0;
                top: 0;
                width: 100%;
                height: 100%;
                overflow: auto;
                background-color: rgba(0,0,0,0.4);
            }
            .modal__container {
                background-color: #fefefe;
                margin: 15% auto;
                padding: 20px;
                border: 1px solid #888;
                width: 80%;
                max-width: 500px;
            }
            .modal__close-button {
                color: #aaa;
                float: right;
                font-size: 28px;
                font-weight: bold;
                cursor: pointer;
            }
            .modal__content {
                color: #000000; /* Texto negro por defecto */
            }
            .modal__content.success {
                color: #000000; /* Texto negro para mensajes de éxito */
            }
            .modal__content.error {
                color: #9a1511; /* Texto rojo para mensajes de error */
            }
        `;
        document.head.appendChild(styleElement);
    }
    showModal(content, type) {
        const modalContent = this.modal.querySelector('#modalContent');
        modalContent.innerHTML = content;
        modalContent.className = `modal__content ${type}`;
        this.modal.style.display = 'block';

        // Forzar un reflow para asegurar que el modal se muestre
        void this.modal.offsetWidth;

        // Agregar una clase para la animación de entrada
        this.modal.classList.add('show');

        // Asegurarse de que el modal esté visible
        setTimeout(() => {
            if (this.modal.style.display !== 'block') {
                console.log('Forzando visibilidad del modal');
                this.modal.style.display = 'block';
            }
        }, 100);
    }

    hideModal() {
        this.modal.classList.remove('show');
        setTimeout(() => {
            this.modal.style.display = 'none';
        }, 300); // Ajusta este tiempo según la duración de tu animación
    }

    initEventListeners() {
        this.container.addEventListener('submit', this.handleSubmit.bind(this));
        this.domElements.submitButton.addEventListener('click', this.handleSubmit.bind(this));
        this.domElements.cancelButton.addEventListener('click', () => this.container.reset());
        this.domElements.files.forEach((fileInput, index) => {
            fileInput.addEventListener('change', () => this.handleFileChange(index));
        });
    }

    handleSubmit(event) {
        event.preventDefault();
        this.doSubmit();
    }

    handleFileChange(index) {
        const fileInput = this.domElements.files[index];
        const file = fileInput.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = (e) => {
                this.files[`file${index + 1}`] = {
                    name: file.name,
                    contents: e.target.result
                };
            };
            reader.readAsDataURL(file);
        }
    }

    validateForm() {
        const errorElements = this.container.querySelectorAll('.error-message');
        errorElements.forEach(el => el.remove());

        let isValid = true;

        if (!this.validateText(this.domElements.socialName, this.translations.socialNameEmpty)) isValid = false;
        if (!this.validateText(this.domElements.cifnif, this.translations.cifnifEmpty)) isValid = false;
        if (!this.validateEmailField(this.domElements.email, this.translations.invalidEmail)) isValid = false;
        if (!this.validateSelect(this.domElements.businesstype, this.translations.businessTypeRequired)) isValid = false;
        // if (!this.validateFiles(this.domElements.files, this.translations.attachmentEmpty)) isValid = false;

        return isValid;
    }

    validateText(input, errorMessage) {
        if (input.value.trim() === '') {
            this.showError(input, errorMessage);
            return false;
        }
        return true;
    }

    validateEmailField(input, errorMessage) {
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailPattern.test(input.value)) {
            this.showError(input, errorMessage);
            return false;
        }
        return true;
    }

    validateSelect(input, errorMessage) {
        if (input.value === '') {
            this.showError(input, errorMessage);
            return false;
        }
        return true;
    }


    // Podemos mantener este méthod por si se necesita en el futuro, pero no lo usaremos en la validación
    validateFiles(inputs, errorMessage) {
        const filesSelected = inputs.some(input => input.files.length > 0);
        if (!filesSelected) {
            // No mostramos error, ya que ahora es opcional
            // this.showError(inputs[0], errorMessage);
            return true; // Siempre retorna true ya que es opcional
        }
        return true;
    }

    showError(input, message) {
        const error = document.createElement('div');
        error.className = 'error-message';
        error.textContent = message;
        input.parentElement.appendChild(error);
    }

    doSubmit() {
        if (this.validateForm()) {
            this.submitForm();
        }
    }

    async submitForm() {
        console.log('Iniciando submitForm()');
        try {
            this.domElements.submitButton.disabled = true;
            this.domElements.submitButton.textContent = 'Enviando...';

            const formData = new FormData(this.container);
            const payload = {
                firstname: formData.get('first_name'),
                lastname: formData.get('last_name'),
                email: formData.get('email'),
                idnumber: formData.get('id_number'),
                commercial_name: formData.get('commercial_name'),
                businesstype: formData.get('business_type'),
                files: this.files,
                shop: Shopify.shop
            };

            console.log('Payload:', payload);

            const registerResponse = await fetch('http://padelmarket4.lineagrafica.es/api/b2b/register', {
                method: 'POST',
                body: JSON.stringify(payload),
                headers: {
                    'Content-Type': 'application/json'
                }
            });

            if (!registerResponse.ok) {
                throw new Error('Error al enviar el formulario');
            }

            const registerResponseDecoded = await registerResponse.json();
            console.log('Respuesta del servidor:', registerResponseDecoded);

            this.showSuccessMessage();
        } catch (error) {
            console.error('Error en submitForm:', error);
            this.showErrorMessage(error.message);
        } finally {
            this.domElements.submitButton.disabled = false;
            this.domElements.submitButton.textContent = 'CREAR CUENTA';
        }
    }

    showSuccessMessage() {
        console.log('Mostrando mensaje de éxito');
        const content = `
            <h2>¡Éxito!</h2>
            <p>Tu información ha sido enviada con éxito. Hemos creado tu cuenta de cliente, en breves nos pondremos en contacto contigo.</p>
        `;
        this.showModal(content, 'success');
        this.container.reset();
        console.log('Modal debería ser visible ahora');

    }

    showErrorMessage(message) {
        console.log('Mostrando mensaje de error');
        const content = `
            <h2>Error</h2>
            <p>${message}</p>
            <p>Por favor, inténtalo de nuevo.</p>
        `;
        this.showModal(content, 'error');
        console.log('Modal de error debería ser visible ahora');

    }
}

document.addEventListener("DOMContentLoaded", function() {
    new CustomerFormAPP('#create_customer');

    // Añadir mensaje descriptivo para los campos de archivo!
    const fileUploadSection = document.querySelector('.file-upload-section'); // Asegúrate de que este selector sea correcto
    if (fileUploadSection) {
        const descriptionMessage = document.createElement('p');
        descriptionMessage.textContent = 'Subir fotos de tu tienda, club o web';
        descriptionMessage.style.fontSize = '0.9em';
        descriptionMessage.style.color = '#666';
        descriptionMessage.style.marginTop = '5px';
        fileUploadSection.appendChild(descriptionMessage);
    }

    const fileInputs = ['file1', 'file2', 'file3'];
    const allFilesSelectedMessage = document.getElementById('all_files_selected');

    function checkAllFilesSelected() {
        const allSelected = fileInputs.every(id => document.getElementById(id).files.length > 0);
        if (allFilesSelectedMessage) {
            allFilesSelectedMessage.style.display = allSelected ? 'block' : 'none';
        }
    }

    fileInputs.forEach((id, index) => {
        const fileInput = document.getElementById(id);
        if (fileInput) {
            fileInput.addEventListener('change', function() {
                const textFileElement = document.getElementById(`text_${this.id}`);
                const nextUploadSection = document.getElementById(`upload_section${index + 2}`);

                if (textFileElement) {
                    if (this.files.length > 0) {
                        textFileElement.textContent = this.files[0].name;
                        if (nextUploadSection) {
                            nextUploadSection.style.display = 'block';
                        }
                    } else {
                        textFileElement.textContent = 'Ningún archivo seleccionado';
                        if (nextUploadSection) {
                            nextUploadSection.style.display = 'none';
                        }
                    }
                } else {
                    console.error(`No element found with ID text_${this.id}`);
                }

                checkAllFilesSelected();
            });
        }
    });
});
